import { type FC } from "react";
import { Button } from "@root/shared/components/Button";
import { Icon } from "@root/shared/components/Icon";
import { TextButton } from "@root/shared/components/TextButton";
import Modal from "@root/shared/components/Modal";
import { getReasonTexts } from "@clientFrontend/features/scout/components/PremiumScoutMessageArea/utils/getReasonTexts";
import {
  type DisplayDisableReason,
  type DisableButtonText,
} from "@clientFrontend/features/scout/components/PremiumScoutMessageArea/type";
import * as styles from "./styles.css";

type Props = {
  disableText: DisableButtonText;
  displayDisableReason: DisplayDisableReason;
  isShowSupplementModal: boolean;
  handleClickOpenSupplementModal: () => void;
  handleClickCloseSupplementModal: () => void;
};

export const DisableAiScoutMessageButton: FC<Props> = ({
  disableText,
  displayDisableReason,
  isShowSupplementModal,
  handleClickCloseSupplementModal,
  handleClickOpenSupplementModal,
}) => {
  return (
    <>
      <div className={styles.wrapper}>
        <Button theme="disabled" disabled className={styles.createButton}>
          <Icon name="sparkle" />
          AIでメッセージを作成する
        </Button>
        <div className={styles.disableButtonWrapper}>
          <TextButton size="large" onClick={handleClickOpenSupplementModal}>
            {disableText}
            {disableText === "AIでメッセージを作成できません" && (
              <span className={styles.iconWrapper}>
                <Icon name="tooltip" fontSize="16px" />
              </span>
            )}
          </TextButton>
        </div>
      </div>
      {displayDisableReason && (
        <>
          <Modal
            onClose={handleClickCloseSupplementModal}
            headerTitleStyle="none"
            footerContentStyle="none"
            pcWidthType="small"
            spAppearanceType="center"
            isShow={isShowSupplementModal}
          >
            <>
              <p className={styles.boldText}>{getReasonTexts(displayDisableReason).boldText}</p>
              <p className={styles.text}>{getReasonTexts(displayDisableReason).text}</p>
            </>
          </Modal>
        </>
      )}
    </>
  );
};
